class Stagger {
  constructor() {
    this.trigger = document.querySelector('[data-trigger="stagger"]');
    this.initialDelay = 1500; // Update this value to adjust opening delay
    this.velocity = 200; // Update this value to adjust speed
    this.init();
  }

  init() {
    if (this.trigger) {
      setTimeout(() => {
        this.staggerAnimation();
      }, this.initialDelay);
    }
  }

  staggerAnimation() {
    const item = document.querySelector('[data-target="stagger"]');
    const targets = this.trigger.querySelectorAll('[data-target="stagger"]');

    for (let index = 0; index < targets.length; index++) {
      const delay = index * this.velocity;
      const item = targets[index];

      setTimeout(() => {
        targets[index].setAttribute("data-stagger", "finished");
      }, delay);
    }
  }
}

export const stagger = new Stagger();
